import React, { useEffect, useRef, useState } from "react";
import { Button, Image, NavBar } from "antd-mobile";
import { APPLICATION_SCREEN, ISwitchScreenAction } from "../App";
import moment from "moment";
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getAuth, signInWithPopup, GoogleAuthProvider, signInAnonymously, onAuthStateChanged } from "firebase/auth";
import { child, getDatabase, ref, set } from "firebase/database";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Lottie from 'react-lottie';
import { getRemoteConfig, getValue, fetchAndActivate } from "firebase/remote-config";

export const firebaseConfig = {
  apiKey: "AIzaSyAXvGqyE54viNIf3O8sqDJbDqMIKoHBxNY",
  authDomain: "ecosystem-8886.firebaseapp.com",
  databaseURL: "https://ecosystem-8886.firebaseio.com",
  projectId: "ecosystem-8886",
  storageBucket: "ecosystem-8886.appspot.com",
  messagingSenderId: "214855080530",
  appId: "1:214855080530:web:afb3a9f55aba7908c45d8b",
  measurementId: "G-60YSQM00CC"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics();
const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 36000;

import animationData from './../anim/loading.json';
import { getTuyaDeviceInfo } from "../common/TuyaRequests";
import { MAIN_COLOR, TELEGRAM_GROUP_ID, TELEGRAM_TOKEN_HOROSCOPE } from "../common/Constants";
import { sendTelegramMessage } from "../common/utils";

const defaultAnimationOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData, // Provide your animation data here
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

export default function Splash({ setScreen }: ISwitchScreenAction) {
  const [countdown, setCountDown] = useState(20 * 1000)
  const [loggedIn, setLoggedIn] = useState(false);
  const timeoutCountDown = useRef(0)
  const [videoLink, setVideoLink] = useState<string | undefined>()
  const [imageLink, setImageLink] = useState<string | undefined>()
  const [loading, setLoading] = useState(true)
  const [gotConfig, setGotConfig] = useState(false)
  const [randomPublicImage, setRandomPublicImage] = useState<string | undefined>()

  // Biến điều khiển: true = chỉ hiển thị random public images, false = random cả videoLink + public images
  const SHOW_ONLY_PUBLIC_IMAGES = true


  const getLogin = async () => {
    const auth = getAuth();
    signInAnonymously(auth)
      .then((user) => {
        console.log('Prepared data!', user)
        setLoggedIn(true)
      })
      .catch((error) => {
        console.error(error);
      });
  }

  const randomItem = (items: string[]) => {
    if (!items) {
      return 0
    }
    const randomNumber = Math.floor(Math.random() * items.length);
    if (randomNumber === items.length) {
      return items.length - 1
    }
    return randomNumber
  }

  const getRandomPublicImage = () => {
    const imageNumber = Math.floor(Math.random() * 15) + 1; // Random từ 1 đến 15
    return `bg${imageNumber}.jpg`;
  }

  const fetchRemoteConfigData = async () => {
    try {
      // Fetch and activate remote config
      await fetchAndActivate(remoteConfig);

      // Get the value of 'welcome_message' from remote config
      const data = getValue(remoteConfig, "gift_links").asString();
      console.log('RM:', data)
      if (data) {
        const dataJson = JSON.parse(data)
        console.log(dataJson)
        const images = dataJson.images
        const videos = dataJson.videos
        let _videoLink = undefined
        let _imageLink = undefined
        if (videos && videos.length > 0) {
          const index = randomItem(videos)
          console.log(index)
          _videoLink = videos[index]
        } else if (images && images.length > 0) {
          const index = randomItem(images)
          _imageLink = images[index]
        }


        // Logic random khi đã lấy được config
        if (SHOW_ONLY_PUBLIC_IMAGES) {
          // Chỉ hiển thị random public images
          console.log('Show only public images')
          const randomImage = getRandomPublicImage();
          setRandomPublicImage(randomImage);
          setVideoLink(undefined);
          setImageLink(undefined);
        } else {
          // Random giữa videoLink và public images
          const shouldShowPublicImage = Math.random() < 0.5; // 50% chance
          console.log('Should show public image:', shouldShowPublicImage, '. videoLink:', _videoLink)
          if (shouldShowPublicImage || !_videoLink) {
            const randomImage = getRandomPublicImage();
            setRandomPublicImage(randomImage);
          } else {
            setVideoLink(_videoLink);
          }
        }
      }
      logEvent(analytics, 'gift_remote_config_fetched');
    } catch (error) {
      logEvent(analytics, 'gift_remote_config_fetch_failed)');
      console.error('Error fetching remote config: ', error);
    }

    setTimeout(() => {
      setGotConfig(true)
    }, 3000)
  }

  const gotoHome = () => {
    setScreen(APPLICATION_SCREEN.HOME)
  }

  useEffect(() => {

    if (countdown <= 0) {
      window.clearInterval(timeoutCountDown.current)
      sendTelegramMessage(TELEGRAM_GROUP_ID, TELEGRAM_TOKEN_HOROSCOPE, 'Splash -> Home')
      gotoHome()
      return
    };

    timeoutCountDown.current = window.setInterval(() => {
      setCountDown((prev) => prev - 1000);
    }, 1000);

    return () => {
      window.clearInterval(timeoutCountDown.current)
    }
  }, [countdown])

  useEffect(() => {
    fetchRemoteConfigData()
    getLogin()
  }, [])

  useEffect(() => {
    if (!videoLink) {
      return;
    }
    const video = document.getElementById('splashVideo');
    if (video) {
      try {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) { // Safari
          video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) { // IE/Edge
          video.msRequestFullscreen();
        }
      } catch (error) {
        console.log(error)
      }
    }
  }, [videoLink])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', fontSize: 18, fontWeight: 'bold', color: '#000000' }}>
      <div style={{flex: 1, width: '100vw', height: '100vh', position: 'absolute'}}>
        {/* {!imageLink && !videoLink && !randomPublicImage && <Image src={'/bg1.jpg'} width={'100%'} height={'100%'} fit='contain' />} */}
        {randomPublicImage && <Image src={`/${randomPublicImage}`} width={'100%'} height={'100%'} fit='contain' style={{ background: 'white' }} />}
      </div>
      <div>
        {videoLink && <video id="splashVideo" width='100%' playsInline controls={false} height='100%'
          src={videoLink} autoPlay muted />}

        {countdown >= 0 && loggedIn && <div style={{
          position: "absolute",
          bottom: 56,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          left: 0, right: 0, width: '100%'
        }}>
          <span onClick={() => {
            gotoHome()
            sendTelegramMessage(TELEGRAM_GROUP_ID, TELEGRAM_TOKEN_HOROSCOPE, 'Skip Splash')
          }} style={{
            borderWidth: 1,
            borderStyle: 'solid',
            padding: 8,
            color: gotConfig ? MAIN_COLOR : 'grey',
            textShadow: '0 2 3 ' + MAIN_COLOR,
            borderRadius: 12,
            borderColor: MAIN_COLOR
          }}>
            Tiếp tục trong {countdown / 1000}
          </span>
        </div>}
        {/* Load image from public resources, there are 15 images, namely bg1.jpg -> bg15.jpg */}
        
        {/* {imageLink && <Image src={imageLink} width={'100%'} height={'100%'} fit='cover'/>} */}
        {!gotConfig && <div style={{ position: 'absolute', display: 'flex', alignItems: 'center', opacity: 0.4, width: '100%', height: '100%' }}>
          <Lottie
            options={defaultAnimationOptions}
            height={124}
            width={124}
          />
        </div>}
      </div>

    </div>
  );
}
